import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardMedia from '@material-ui/core/CardMedia'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Typography from '@material-ui/core/Typography'
import ButtonCta from '@components/atoms/button-cta'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '300px',
    height: '285px',
    borderRadius: '8px',
    marginTop: '-8px',
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.palette.shadow.cardBoxShadow,
  },
  image: {
    width: '100%',
    height: '150px',
    backgroundSize: '600px',
    backgroundPosition: 'top -2rem left -7rem',
  },
  headline: {
    ...theme.typography.h5,
    color: theme.palette.common.white,
    lineHeight: 'normal',
    textShadow: '0px 2px 16px rgba(0, 10, 22, 0.50)',
    width: '150px',
    height: '100%',
    paddingTop: '55px',
    marginLeft: '24px',
  },
  content: {
    height: '65px',
  },
  body: {
    ...theme.typography.body2,
    lineHeight: 'normal',
    paddingRight: '30px',
  },
  actions: {
    padding: '0 16px',
    height: '55px',
  },
}))

function CtaCard(props) {
  const { ctaImage, ...rest } = props
  const classes = useStyles()

  return (
    <Card className={classes.root} {...rest}>
      <CardMedia
        className={classes.image}
        image={ctaImage}
        alt="golfers"
        title="golfers"
      >
        <Typography className={classes.headline}>Discover Golf Events Near You!</Typography>
      </CardMedia>
      <CardContent className={classes.content}>
        <Typography className={classes.body}>Search for fun things to do in your area led by PGA Professionals.</Typography>
      </CardContent>
      <CardActions className={classes.actions}>
        <ButtonCta
          size="small"
          variant="contained"
          color="primary"
          dataAttrs={{
            'aria-label': 'Find events near you',
            'data-gtm-button-name': 'find-events-cta',
            'data-gtm-cta-position': 'card',
          }}
          href="/golf-lessons"
        >
          Find Events Near You
        </ButtonCta>
      </CardActions>
    </Card>
  )
}

CtaCard.propTypes = {
  ctaImage: PropTypes.string,
}

export default CtaCard
